import React, { PureComponent } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import { EditField, Check } from 'components/SvgIcons';
import './style.scss';

class Stage extends PureComponent {
    state = {};

    handleClickGoToStep = () => {
        const { onClickGoToStep, num } = this.props;
        onClickGoToStep(num);
    };

    render() {
        const { stage, literal, num } = this.props;
        let stageClass;
        let stageCircle;
        if (stage === num) {
            stageClass = 'current';
        } else if (num < stage) {
            stageClass = 'previous';
        } else if (num > stage) {
            stageClass = 'next';
        } else {
            stageClass = '';
        }
        if (stage === num) {
            stageCircle = <EditField color={'$fmWhite'} />;
        } else if (stage > num) {
            stageCircle = <Check color={'$fmWhite'} />;
        } else {
            stageCircle = num;
        }
        return (
            <div className="stage-container">
                <div className="stage-circle-container">
                    <div className={`stage-circle ${stageClass}`}>{stageCircle}</div>
                </div>
                <div className={`stage-name ${stageClass}`}>
                    <Literal literal={literal} />
                </div>
                <div className="stage-line-container">
                    <hr className={`stage-line ${stageClass}`} />
                </div>
            </div>
        );
    }
}

export default Stage;
